<script setup lang="js">
import { onMounted, ref } from 'vue';
import { useProjectStore } from '@/stores/project.store';
import { useRouteParams } from '@vueuse/router';
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';
import { storeToRefs } from 'pinia';
import { useRoleStore } from '@/stores/role.store';

const projectStore = useProjectStore();
const roleStore = useRoleStore();
const projectId = useRouteParams('projectId');
const { closeModal } = useModal();
const title = ref({});
const name = ref('');
const { project } = storeToRefs(projectStore);
const { createRoleRequest } = storeToRefs(roleStore);

onMounted(() => {
  projectStore.getProject(projectId.value);
});

function createRole() {
  roleStore.createRole(title.value, name.value).then(() => {
    roleStore.getRoleList();
    closeModal();
  });
}
function isErrorField(fieldName) {
  if (createRoleRequest.value.error?.errors) {
    return createRoleRequest.value.error.errors[fieldName] || false;
  }
}
</script>

<template>
  <ModalTemplateSide @submit="createRole" :disableButtons="createRoleRequest.isLoading">
    <template v-slot:title>Создать роль</template>
    <template v-slot:body>
      <div class="mt-3">
        <label class="form-label">Системное название</label>
        <input type="text" v-model="name" class="form-control" :class="{ 'error': isErrorField('name') }" />
      </div>
      <div class="mt-3" v-for="locale in project.locales" :key="locale.id">
        <label class="form-label">Наименование роли на {{ locale.name }}</label>
        <input type="text" v-model="title[locale.id]" class="form-control" :class="{ 'error': isErrorField('title') }" />
      </div>
      <p v-if="isErrorField('title')" class="error-mesage">
        <span v-for="error in isErrorField('title')">{{ error }}</span>
      </p>
    </template>
    <template v-slot:submit>Создать</template>
  </ModalTemplateSide>
</template>
